import { apiFetch } from './http';
import { shouldBlockOperatorWebLogin } from './webLoginAccess';

/** DB acknowledgement and profile lookup must finish before signing out. */
export async function finishPasswordSetup(): Promise<string> {
  const completed = await apiFetch('/api/auth/complete-password', { method: 'POST', credentials: 'omit' });
  if (!completed.ok) throw new Error('Your password was saved, but account setup could not finish. Retry to complete setup.');
  const response = await apiFetch('/api/users/me', { credentials: 'omit' });
  if (!response.ok) throw new Error('Your password was saved, but account access could not be checked. Retry to complete setup.');
  const { user } = await response.json();
  if (!user?.role) throw new Error('Your account profile could not be verified. Retry to complete setup.');
  return shouldBlockOperatorWebLogin(user) ? '/auth/mobile-ready' : '/login';
}
